import { render, staticRenderFns } from "./c_comb_data.vue?vue&type=template&id=eebc1daa&scoped=true"
import script from "./c_comb_data.vue?vue&type=script&lang=js"
export * from "./c_comb_data.vue?vue&type=script&lang=js"
import style0 from "./c_comb_data.vue?vue&type=style&index=0&id=eebc1daa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebc1daa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eebc1daa')) {
      api.createRecord('eebc1daa', component.options)
    } else {
      api.reload('eebc1daa', component.options)
    }
    module.hot.accept("./c_comb_data.vue?vue&type=template&id=eebc1daa&scoped=true", function () {
      api.rerender('eebc1daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_comb_data.vue"
export default component.exports